import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./review.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import equalityFn from 'zustand/shallow';
import { CommentStatus, LikeStatus } from '~/modules/services/reviewService';
import { i18nStore, WireI18n } from '~/modules/stores/i18nStore';
import { reviewStore } from '~/modules/stores/reviewStore';
import { selectProfile, userStore } from '~/modules/stores/userStore';
import { sendNotification } from '~/modules/utilities/notificationUtilities';
import webTemplate from './review.html';
import mobileTemplate from './review_mobile.html';
export const LEGACY_REVIEWER = 'AppExchange Reviewer';
class ReviewTile extends LightningElement {
  constructor(...args) {
    super(...args);
    this.isMobile = false;
    this.review = void 0;
    this.isSingleReview = false;
    this.isModalShown = false;
    this.isReportingAbuse = void 0;
  }
  i18nCallback(i18n) {
    this.reviewLabels = i18n.listingDetails.review;
    this.reportAbuseModalLabels = i18n.modals.reportAbuse;
    this.sharedLabels = i18n.shared;
    this.starsLabel = i18nStore.getState().i18n.starRatings.ariaLabelStar({
      CURRENT_STAR: this.review.rating,
      NUMBER_OF_STARS: 5
    });
    this.likeCount = i18nStore.getState().i18n.listingDetails.review.likeCount({
      LIKE_COUNT: this.review.likeCount
    });
    this.reviewerName = i18nStore.getState().i18n.shared.userName({
      FIRST_NAME: this.review?.user?.firstName ?? '',
      LAST_NAME: this.review?.user?.lastName ?? ''
    });
  }
  setUserState(userProfile) {
    this.userProfile = userProfile;
  }
  render() {
    return this.isMobile ? mobileTemplate : webTemplate;
  }
  renderedCallback() {
    if (this.review.commentBoxShown) {
      // @ts-expect-error * Automated Type Error Fix
      this.template.querySelector('textarea').focus();
    }
  }
  toggleModal() {
    this.isModalShown = !this.isModalShown;
    this.reportAbuseButtonRef?.focus();
  }
  get dynamicLabels() {
    return {
      likeCount: i18nStore.getState().i18n.listingDetails.review.likeCount({
        LIKE_COUNT: this.review.likeCount
      })
    };
  }
  get hasProfileLink() {
    return this.review.user.profileLink;
  }
  get likeVariant() {
    if (this.isLiked || this.isLiking) {
      return 'primary';
    }
    return 'secondary';
  }
  get isLiking() {
    return this.review.likeStatus === LikeStatus.inProgress;
  }
  get isLiked() {
    return this.review.likeStatus === LikeStatus.liked;
  }
  get showCommentBox() {
    return this.review.commentBoxShown;
  }
  get isCommenting() {
    return this.review.commentStatus === CommentStatus.IN_PROGRESS;
  }
  get isLegacyReviewer() {
    return this.review.user.name === LEGACY_REVIEWER;
  }
  get reportAbuseButtonRef() {
    return this.template.querySelector('.report-abuse-btn');
  }
  get commentButtonRef() {
    return this.template.querySelector('.comment-button');
  }
  get avatarLinkAriaLabel() {
    return i18nStore.getState().i18n.shared.avatarLinkAriaLabel({
      USER_NAME: this.reviewerName
    });
  }
  get defaultAvatarAltText() {
    return this.sharedLabels.defaultAvatarAltText;
  }

  // @ts-expect-error * Automated Type Error Fix
  handleLike(event) {
    if (this.review.likeStatus === LikeStatus.unliked) {
      this.dispatchEvent(new CustomEvent('like', {
        detail: {
          reviewId: this.review.id,
          originalTarget: event.currentTarget
        }
      }));
    }
    if (this.isLiked) {
      this.dispatchEvent(new CustomEvent('unlike', {
        detail: {
          reviewId: this.review.id,
          likeId: this.review.userLikeId,
          originalTarget: event.currentTarget
        }
      }));
    }
  }
  openCommentCreator() {
    if (this.userProfile.isGuestUser) {
      return window.SFIDWidget.login();
    }
    return reviewStore.openCommentBox(this.review.id, this.isSingleReview);
  }
  closeCommentCreator() {
    reviewStore.closeCommentBox(this.review.id, this.isSingleReview);
    // @ts-expect-error * Automated Type Error Fix
    this.commentButtonRef.focus();
  }
  async commentReview() {
    const previousFocusedElement = this.commentButtonRef;
    // @ts-expect-error * Automated Type Error Fix
    const comment = this.template.querySelector('textarea').value;
    const response = await reviewStore.comment(this.review.id, comment, this.isSingleReview);
    if (response.isSuccess) {
      const {
        successMessage
      } = response;
      // @ts-expect-error * Automated Type Error Fix
      sendNotification(successMessage, {
        previousFocusedElement
      });
    } else {
      const {
        errorMessage,
        exceptionInfo
      } = response;
      // @ts-expect-error * Automated Type Error Fix
      sendNotification(errorMessage, {
        exceptionInfo,
        previousFocusedElement
      });
    }
  }
  handleOpenReportAbuse() {
    if (this.userProfile.isGuestUser) {
      return window.SFIDWidget.login();
    }
    return this.toggleModal();
  }

  // @ts-expect-error * Automated Type Error Fix
  handleSingleReview(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('showreview', {
      detail: {
        review: this.review
      }
    }));
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(ReviewTile, {
  publicProps: {
    isMobile: {
      config: 0
    },
    review: {
      config: 0
    },
    isSingleReview: {
      config: 0
    }
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    setUserState: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectProfile,
          equalityFn
        };
      }
    },
    isReportingAbuse: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: reviewStore,
          selector: state => state.isReportingAbuse
        };
      }
    }
  },
  fields: ["isModalShown"]
});
const __lwc_component_class_internal = _registerComponent(ReviewTile, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;